import { Route, Routes } from 'react-router-dom';

import { ROUTES } from '@/config/routes';
import { EmailLayout } from '@/features/email/layouts/EmailLayout';

import { EmailDashboard } from './Dashboard';

const { email } = ROUTES.children;

export const EmailRoutes = () => {
  return (
    <Routes>
      <Route element={<EmailLayout />}>
        <Route path={email.children.dashboard.base} element={<EmailDashboard />} />
      </Route>
    </Routes>
  );
};
